<template>
  <div>
    <TopBar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-3" style="padding:20px;">
          <MenuSetup />
        </div>
        <div class="col-sm-7">
          <a href="#/usb" class="box">
            <div>
              <h3>{{ $t('progUSB') }}</h3>
              <img src="../assets/prog_usb2.png"/>
            </div>
          </a>
          <a v-if="lShowKiBolt"  href="#/kiprog" class="box">
            <div>
              <h3>{{ $t('progKiProg') }}</h3>
              <img src="https://img.intratone.info/Images/Programmateur/kiprog.png" style="height:80px;" />
            </div>
          </a>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'
import MenuSetup from './MenuSetup.vue'
export default {
  name: 'Home',
  computed: {
      lShowKiBolt () {
        return this.$store.state.showKibolt;
      }
  },
  components: {
      TopBar,
      MenuSetup
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.box {
  text-decoration: none;
}
.box {
  display: block;
  margin:30px;
  background: #f2f2f2;
  padding: 20px;
  text-align: center;
  border-radius: 6px;
  color:grey;
}
.box img{
  max-height: 20px;
}
</style>
